/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ExportOfficeRestService, OfficeRestService, ScheduleType } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { FilteredDataQuery, getSlicedData } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { OfficeListItem, SendToOfficeItem } from './office-export.model';

@Injectable()
export class ExportOfficeBusinessService implements InitViewService {

  constructor(private dictionaryService: DictionaryService,
              private restService: ExportOfficeRestService,
              private officeRest: OfficeRestService) {
  }

  initView(): any {
    return {
      scheduleType: this.dictionaryService.getByEnum(ScheduleType),
    };
  }

  sendToOffice(data: SendToOfficeItem): Observable<any> {
    return this.restService.sendToOffice(data);
  }

  findOfficesByName(query: FilteredDataQuery<string>): Observable<OfficeListItem[]> {
    return this.officeRest
      .findAllAsAutocompleteDataSource(<string>query.filter)
      .select(query)
      .pipe(map$(getSlicedData));
  }
}
